/**
 * PublicHearingSnapshot.js — Captura automática do print do painel público (telão) da
 * audiência, usada ao gerar o Capítulo 14 do PMAU (ver Pmau.vue Generate()).
 *
 * Monta o componente real do painel (mesmo exibido no telão durante o evento) fora da
 * tela, aguarda o carregamento dos dados e do gráfico, tira o print via html2canvas e
 * envia ao backend — que substitui o snapshot anterior do evento. Não exige nenhuma ação
 * manual: acontece "debaixo dos panos" a cada geração do capítulo.
 */

import Vue from "vue";
import html2canvas from "html2canvas";
import PublicHearingPanel from "../views/Public/PublicHearingPanel";
import PublicHearingService from "../servico/PublicHearingService";

const PanelConstructor = Vue.extend(PublicHearingPanel);

/**
 * Nunca lança exceção — falha na captura do print não deve impedir a geração do
 * capítulo (o texto simplesmente sai sem a figura do painel).
 */
export async function capturePublicHearingPanelSnapshot(eventId, publicToken) {
  if (!eventId || !publicToken) return false;

  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.top = "-9999px";
  container.style.left = "-9999px";
  container.style.width = "1600px";
  document.body.appendChild(container);

  const vm = new PanelConstructor({ propsData: { tokenOverride: publicToken } });

  try {
    vm.$mount(container);
    await vm.carregar(true);
    await vm.$nextTick();
    // Highcharts/QR terminam de desenhar um instante depois do $nextTick.
    await new Promise((resolve) => setTimeout(resolve, 500));

    if (!vm.dados) return false;

    const canvas = await html2canvas(container, { backgroundColor: "#ffffff", useCORS: true });
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
    if (!blob) return false;

    await PublicHearingService.UploadPanelSnapshot(eventId, blob);
    return true;
  } catch (e) {
    console.error("[PublicHearingSnapshot] Falha ao capturar print do painel", e);
    return false;
  } finally {
    vm.$destroy();
    if (container.parentNode) container.parentNode.removeChild(container);
  }
}
